import React from "react";
import "./Tooltip.styles.scss";

const Tooltip = ({ isShown, children }) => {

    return (
        <div
            className={`tooltip ${isShown ? 'tooltip--shown' : ''}`}
        >
            {children}
        </div>
    )
};

export default Tooltip;